import { Router } from "@vaadin/router";
import { LitElement, property } from "lit-element";
import { html } from "lit-html";
import { httpError } from "../../store/httpError.js";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import KbParser from "../../utils/KbParser";

/**
 * Used to render helpset & direct helpset topics
 */
export class KbTopicExperimental extends LitElement {
  @property({ type: String }) htmlBody?: string;
  @property({ type: Object }) metadata?: TocNodeLike;
  @property({ type: String }) status: "" | "loading" | "success" | "error" = "";
  topicContainer?: HTMLElement;

  connectedCallback(): void {
    super.connectedCallback();
  }

  async updated(changedProperties: Map<string, any>) {
    if (changedProperties.has("metadata")) {
      this.fetchHtmlBody();
    }
  }

  firstUpdated() {
    this.topicContainer = this.shadowRoot.querySelector("#topic-container");
  }

  async fetchHtmlBody(): Promise<void> {
    try {
      this.status = "loading";
      let response = new Response();
      if (this.metadata?.href) {
        response = await fetch(`/kb/jrest/getHtmlBody?kbrid=${this.metadata.href}`);
      }
      if (!response.ok) {
        this.status = "error";
        httpError(response);
        throw Error();
      }
      let rawHtml = await response.text();
      this.processHtml(rawHtml);
    } catch (e) {
      console.log("ERROR");
    }
  }

  dispatchTopicLoaded() {
    let options = {
      detail: {
        ...this.metadata,
      },
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent("topicLoaded", options));
  }

  getKbridFromSrc(src: string): string {
    let parts = src.split("/");
    if (parts.length > 0) {
      return parts[parts.length - 1];
    }
    return src;
  }

  fetchImages(doc: Document) {
    let imageElements = doc.querySelectorAll("img");
    imageElements.forEach((el) => {
      let kbrid = this.getKbridFromSrc(el.src);
      el.src = `/kb/jrest/getResource?kbrid=${kbrid}`;
    });
    this.htmlBody = doc.body.innerHTML;
  }

  processHtml(content: string) {
    let parsedHtml = new DOMParser().parseFromString(content, "text/html");
    this.fetchImages(parsedHtml);
    this.dispatchTopicLoaded();
    this.status = "success";
    // this.attachClickBehavior();
  }

  // -- Link behaviour --

  // attachClickBehavior() {
  //   var linkElements = this.topicContainer.querySelectorAll("a");
  //   linkElements.forEach(async (el) => {
  //     if (KbParser.isKbrid(el.getAttribute("href"))) {
  //       await this._handleKbrid(el);
  //     }
  //   });
  // }

  // async _handleKbrid(el) {
  //   let parser = new KbParser();
  //   parser.setHref(el.getAttribute("href"));
  //   let parsedLink = parser.parse();
  //   let newLink = this.imputeShortcutExtId(parsedLink);
  //   let item = await parser.getItem();
  //   el.addEventListener("click", async (e) => {
  //     e.preventDefault();
  //     if (el.getAttribute("target") === "_blank") {
  //       window.open(newLink, "_blank");
  //     }
  //     storeInstance.dispatch("setState", { property: "item", value: item });
  //     Router.go(newLink);
  //   });
  // }

  // imputeShortcutExtId(newLink) {
  //   if (this.isShortcutLink(newLink)) {
  //     let linkRouteParams = newLink.split("/");
  //     linkRouteParams[this.extIdIndex] = this.locationExtId
  //       ? this.locationExtId
  //       : linkRouteParams[this.extIdIndex];
  //     return linkRouteParams.join("/");
  //   }
  //   return newLink;
  // }

  // isShortcutLink(newLink) {
  //   if (this.locationExtId) {
  //     let linkExternalId = newLink?.split("/")[this.extIdIndex];
  //     return this.state.item.item.externalId === linkExternalId; // item is targetItem is this case
  //   }
  //   return false;
  // }

  //   --- Templates ---

  blankTemplate() {
    return html`<p>Blank</p>`;
  }

  loadingTemplate() {
    return html` <style>
        .loading-topic {
          height: 65vh;
          background-color: white;
        }
      </style>
      <div class="loading-topic fade article-container"></div>`;
  }

  articleTemplate() {
    return html` <link
        rel="stylesheet"
        type="text/css"
        href="/kb/themes/${theme}/topic/topic.css"
      />
      <style></style>
      <article class="article-container fade">${unsafeHTML(this.htmlBody)}</article>`;
  }

  errorTemplate() {
    return html`<p>Loading...</p>`;
  }

  topicTemplate() {
    switch (this.status) {
      case "":
        return this.blankTemplate();
      case "loading":
        return this.loadingTemplate();
      case "success":
        return this.articleTemplate();
      case "error":
        return this.errorTemplate();
    }
  }

  render() {
    return html` <style>
        article {
          border-radius: 8px;
          border: 1px solid gainsboro;
          background: white;
        }

        .article-container {
          margin: 2rem auto;
          width: 80%;
          padding: 2rem 4rem;
        }

        .fade {
          opacity: 0;
          animation-name: fadeIn;
          animation-duration: 450ms, 600ms;
          animation-timing-function: linear, ease;
          animation-delay: 400ms;
          animation-fill-mode: forwards;
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      </style>
      <div id="topic-container">${this.topicTemplate()}</div>`;
  }
}

customElements.define("kb-topic-experimental", KbTopicExperimental);

type TocNode = {
  title: string;
  href?: string;
  nodes?: TocNode[];
};

type TocNodeLike = Pick<TocNode, "title" | "href">;
